import type { OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { ValidatorFn } from '@angular/forms';
import { FormControl, Validators } from '@angular/forms';
import type { Observable } from 'rxjs';
import { debounceTime, of, startWith, switchMap } from 'rxjs';
import type { EntityItemInterface } from '../search-input/select-item.interface';


@Component({
  selector: 'app-autocomplete-selector',
  templateUrl: './autocomplete-selector.component.html',
  styleUrls: ['./autocomplete-selector.component.scss']
})
export class AutocompleteSelectorComponent implements OnInit {
  @Input() filter: (args: string) => Observable<EntityItemInterface[]>;
  @Input() minSearchCharacters = 3;
  @Input() clearButton = false;
  @Input() label: string;
  @Input() resetAfterSelected: boolean;
  @Input() requiredErrorMessage: string;
  @Input() isRequired: boolean;
  @Input() placeholder: string;
  @Input() initialValue?: EntityItemInterface;
  @Input() extraValidators: ValidatorFn[] = [];
  @Output() selectItemChanged = new EventEmitter<EntityItemInterface>();
  @Output() validityChanged = new EventEmitter<boolean>();
  @Output() valueChanged = new EventEmitter<string>();
  @Input() itemCtrl: FormControl = new FormControl();
  filteredItems$: Observable<EntityItemInterface[]> = of([]);

  ngOnInit(): void {

    // let test = this.itemCtrl.errors?.['exists']
    this.filteredItems$ = this.itemCtrl.valueChanges.pipe(debounceTime(500),
      startWith(''),
      switchMap((value) => {
        if (value && typeof (value) === 'string' && value.length >= this.minSearchCharacters) {
          return this.onFilter(value);
        }

        return of([]);
      }),
    );

    let validators: ValidatorFn[] = [];
    if (this.isRequired) {
      validators.push(Validators.required);
    }

    if (this.extraValidators.length > 0) {
      validators = [...validators, ...this.extraValidators];
    }

    if (validators.length > 0) {
      this.itemCtrl.setValidators(validators);
    }
    // this.itemCtrl.setAsyncValidators(this.itemExistValidator());

    this.itemCtrl.valueChanges.subscribe((value: string) => {
      this.validityChanged.emit(this.itemCtrl.valid);
      this.valueChanged.emit(value);
    });

    if (this.initialValue) {
      this.itemCtrl.setValue(this.initialValue);
    }
  }

  displayFn(item: EntityItemInterface): string {
    if (!item) {
      return '';
    }

    return item.label;
  }

  onSelectionChange(event: any) {
    this.selectItemChanged.emit(event.option.value as EntityItemInterface);
    this.validityChanged.emit(this.itemCtrl.valid);
    if (this.resetAfterSelected) {
      this.itemCtrl.setValue('');
    }
  }

  clear() {
    this.itemCtrl.setValue('');
    this.selectItemChanged.emit();
    this.validityChanged.emit(this.itemCtrl.valid);
  }

  private onFilter(value: string): Observable<EntityItemInterface[]> {
    return this.filter(value);
  }

  // itemExistValidator(): AsyncValidatorFn {
  //   return (control: AbstractControl): Observable<ValidationErrors | null> => {
  //     return this.onFilter(control.value).pipe(
  //       map(res => {
  //         console.log(res);
  //         // if res is true, username exists, return true
  //         const item = res.find(i=> i.label.toString() ==  control.value);
  //         return item ? { exists: true } : null;
  //         // NB: Return null if there is no error
  //       })
  //     );
  //   };
  // }
}
